import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Home } from 'lucide-react';

import ErrorPageShell from '../components/ErrorPageShell';

const isCheckoutMode =
  import.meta.env.VITE_CHECKOUT_MODE === 'true' ||
  (typeof window !== 'undefined' && window.location.hostname === 'pay.zerotail.org');

function homeUrl(): string {
  if (isCheckoutMode) return 'https://zerotail.org';
  return '/';
}

export default function NotFound() {
  useEffect(() => {
    document.title = 'Page not found — ZeroTail';
  }, []);

  const href = homeUrl();
  const label = isCheckoutMode ? 'Go to zerotail.org' : 'Back to dashboard';

  return (
    <ErrorPageShell
      title="Page not found"
      description={
        isCheckoutMode
          ? "This page doesn't exist. If you were trying to pay an invoice, use the payment link you received."
          : "The page you're looking for doesn't exist or may have been moved."
      }
    >
      {isCheckoutMode ? (
        <a
          href={href}
          className="inline-flex items-center gap-2 rounded-lg border border-zt-border bg-zt-surface/80 px-4 py-2.5 text-sm font-medium text-slate-100 transition hover:border-zt-primary/50 hover:bg-zt-elevated"
        >
          <Home className="h-4 w-4 text-zt-primary" aria-hidden="true" />
          {label}
        </a>
      ) : (
        <Link
          to={href}
          className="inline-flex items-center gap-2 rounded-lg border border-zt-border bg-zt-surface/80 px-4 py-2.5 text-sm font-medium text-slate-100 transition hover:border-zt-primary/50 hover:bg-zt-elevated"
        >
          <Home className="h-4 w-4 text-zt-primary" aria-hidden="true" />
          {label}
        </Link>
      )}
    </ErrorPageShell>
  );
}